<ng-container>
<div
	class="main-container"
	style="
		position: relative;
		background: url('../assets/img/hero-pattern.png');
		background-size: contain;
		background-repeat: no-repeat;
		background-position: center -40vw;
	"
>
	<!-- Navigation header -->
	<nav
		class="navbar navbar-expand-lg mb-0"
		role="navigation-demo"
	>
		<div class="container">
			<!-- Brand and toggle get grouped for better mobile display -->
			<div class="navbar-translate">
				<a class="navbar-brand" [routerLink]="['/']"
					><img
						style="height: 25px"
						src="assets/img/RegScale_logo_main.svg"
					/>
				</a>
				<div class="d-flex">
					<a
						href="https://go.regscale.com/RegScale-Create-Account"
						class="btn btn-get-started btn-raised btn-round d-lg-none"
					>
						Get Started
					</a>

					<button
						class="navbar-toggler"
						type="button"
						data-toggle="collapse"
						aria-expanded="false"
						aria-label="Toggle navigation"
					>
						<span class="sr-only">Toggle navigation</span>
						<span class="navbar-toggler-icon"></span>
						<span class="navbar-toggler-icon"></span>
						<span class="navbar-toggler-icon"></span>
					</button>
				</div>
			</div>
			<!-- Collect the nav links, forms, and other content for toggling -->
			<div class="collapse navbar-collapse">
				<ul class="navbar-nav ml-auto">
					<li class="dropdown nav-item">
						<a
							class="dropdown-toggle nav-link"
							data-toggle="dropdown"
						>
							Solutions
						</a>
						<div class="dropdown-menu">
							<h6 class="dropdown-header">
								By Industry or Sector
							</h6>
							<a
								[routerLink]="['/government']"
								class="dropdown-item"
								>Government</a
							>
							<a
								[routerLink]="['/financial']"
								class="dropdown-item"
								>Financial Institutions (FIs)</a
							>
							<a
								[routerLink]="['/energy-utilities']"
								class="dropdown-item"
								>Energy and Utilities</a
							>
							<!-- <a [routerLink]="['/smb']" class="dropdown-item">Small to Medium Businesses (SMB)</a> -->
							<div class="dropdown-divider"></div>
							<h6 class="dropdown-header">By Use Case</h6>
							<a
								[routerLink]="['/fedramp']"
								class="dropdown-item"
								>Accelerating FedRAMP</a
							>
							<a
								[routerLink]="['/oscal']"
								class="dropdown-item"
								>Leveraging OSCAL</a
							>
							<!-- 
							<a
								[routerLink]="['/vitg']"
								class="dropdown-item"
								>Threat-Based Modeling with VITG</a
							> -->
              <!-- <a href="#pablo" class="dropdown-item">Audits/Inspections</a>
              <a href="#pablo" class="dropdown-item">Continuous Improvement</a>
              <a href="#pablo" class="dropdown-item">Cyber Security Compliance</a>
              <a href="#pablo" class="dropdown-item">Integrated Risk Management</a>
              <a href="#pablo" class="dropdown-item">Issues Management & POAMs</a>
              <a href="#pablo" class="dropdown-item">Policy Management</a>
              <a href="#pablo" class="dropdown-item">Supply Chain Management and 3rd Party Risk</a> -->
						</div>
					</li>
					<li class="dropdown nav-item">
						<a
							class="dropdown-toggle nav-link"
							data-toggle="dropdown"
						>
							Overview
						</a>
						<div class="dropdown-menu">
							<a [routerLink]="['/modules']" class="dropdown-item"
								>Modules</a
							>
							<a
								[routerLink]="['/features']"
								class="dropdown-item"
								>Features</a
							>
							<a [routerLink]="['/pricing']" class="dropdown-item">
								Pricing
							</a>
							<a
								[routerLink]="['/technology']"
								class="dropdown-item"
								>Technology</a
							>
							<a
								[routerLink]="['/security']"
								class="dropdown-item"
								>Security</a
							>
						</div>
					</li>
					<li class="nav-item">
						<a href="https://regscale.readme.io/docs" target="_blank" class="nav-link">Docs</a>
					</li>
					<li class="nav-item">
						<a
								[routerLink]="['/blog']"
								class="nav-link"
								>Blog</a
							>
					</li>
					<li class="dropdown nav-item">
						<a
							class="dropdown-toggle nav-link"
							data-toggle="dropdown"
						>
							Resources
						</a>
						<div class="dropdown-menu">
							<h6 class="dropdown-header">
								Content Packs
							</h6>
							<a
								[routerLink]="['/regulations']"
								class="dropdown-item"
								>Catalog Downloads</a
							>
							<a
								[routerLink]="['/profiles']"
								class="dropdown-item"
								>Profile Downloads</a
							>
							<a
								[routerLink]="['/other-downloads']"
								class="dropdown-item"
								>Other Downloads</a
							>
							<h6 class="dropdown-header">
								Learning and Reading
							</h6>
							<a
								href="https://regscale.readme.io/" target="_blank"
								class="dropdown-item"
								>Documentation</a
							>
							<a
								[routerLink]="['/training']"
								class="dropdown-item"
								>RegScale University</a
							>
							<a [routerLink]="['/press']" class="dropdown-item"
								>News Room</a
							>
							<a [routerLink]="['/regops']" class="dropdown-item"
								>RegOps Manifesto</a
							>
							<a
								[routerLink]="['/webinars']"
								class="dropdown-item"
								>Webinars</a
							>
							<a
								[routerLink]="['/whitepapers']"
								class="dropdown-item"
								>White Papers</a
							>
							<h6 class="dropdown-header">
								Installation Options
							</h6>
							<a href="https://aws.amazon.com/marketplace/pp/prodview-a3vgw4ruhkav6" class="dropdown-item" target="_blank">
								AWS Marketplace
							</a>
							<a href="https://azuremarketplace.microsoft.com/en-us/marketplace/apps/regscaleinc1663694512998.regscale_continuous_compliance_automation?tab=Overview" class="dropdown-item" target="_blank">
								Azure Marketplace
							</a>
							<a
								[routerLink]="['/gatekeeper/download']"
								class="dropdown-item"
								>Download Container</a
							>
							<a
								[routerLink]="['/gatekeeper/appliance']"
								class="dropdown-item"
								>Download Appliance</a
							>
							<a href="https://artifacthub.io/packages/helm/regscale/regscale" class="dropdown-item" target="_blank">
								Helm Chart
							</a>
							<a
								[routerLink]="['/sbom']"
								class="dropdown-item"
								>Software Bill of Materials (SBOM)</a
							>
						</div>
					</li>
					<li class="dropdown nav-item">
						<a
							class="dropdown-toggle nav-link"
							data-toggle="dropdown"
						>
							Company
						</a>
						<div class="dropdown-menu">
							<a [routerLink]="['/team']" class="dropdown-item"
								>Leadership Team</a
							>
							<a [routerLink]="['/board-of-directors']" class="dropdown-item"
								>Board of Directors</a
							>
							<a
								href="https://www.comeet.com/jobs/regscale/57.00B"
								target="_blank"
								class="dropdown-item"
								>Careers</a
							>
							<a [routerLink]="['/partnership']" class="dropdown-item">
								Partners
							</a>
							<!-- <a href="#pablo" class="dropdown-item">Press</a> -->
							<a [routerLink]="['/contact']" class="dropdown-item"
								>Contact Us</a
							>
							<h6 class="dropdown-header">
								Licensing
							</h6>
							<a href="/assets/license-ee.pdf" class="dropdown-item" target="_blank">Enterprise Edition (EE)</a>
							<a href="/assets/license-mssp.pdf" class="dropdown-item" target="_blank">Managed Security Services Provider (MSSP)</a>
							<a *ngIf="user" [routerLink]="['/dashboard']" class="nav-link">
								<i class="fas fa-cog"></i> Admin Panel 
							</a>
						</div>
					</li>
					<li class="dropdown nav-item">
						<a
							class="dropdown-toggle nav-link"
							data-toggle="dropdown"
						>
							Support
						</a>
						<div class="dropdown-menu">
							<a href="https://support.regscale.com" class="dropdown-item" target="_blank">Open Ticket</a>
							<a
								[routerLink]="['/register']"
								class="dropdown-item"
								>License Registration</a
							>
							<a
								[routerLink]="['/release-notes']"
								class="dropdown-item"
								>Release Notes</a
							>
						</div>
					</li>
					<li class="nav-item d-none d-md-block">
						<a
							href="https://go.regscale.com/RegScale-Create-Account"
							class="btn btn-get-started btn-raised btn-round ml-2"
						>
							Get Started
						</a>
					</li>
				</ul>
			</div>
			<!-- /.navbar-collapse -->
		</div>
		<!-- /.container-->
	</nav>

	<!-- Content -->
	<div class="app-content content">
		<div class="content-wrapper">
			<router-outlet></router-outlet>
		</div>
	</div>

	<!-- Page Footer -->
	<footer class="footer footer-white footer-big py-5">
		<div class="container">
			<div class="content">
				<img
					style="width: 150px; margin-left: -0.2rem"
					src="assets/img/RegScale_logo_main.png"
				/>
				<div class="row mt-4 footer-row">
					<div class="col-md-3">
						<h5>RegScale</h5>
						<ul class="links-vertical">
							<li>
								<a [routerLink]="['/home']" class="footer-link">
									Home
								</a>
							</li>
							<li>
								<a [routerLink]="['/team']" class="footer-link">
									Our Team
								</a>
							</li>
							<li>
								<a
									href="https://www.comeet.com/jobs/regscale/57.00B"
									target="_blank"
									class="footer-link"
								>
									Careers
								</a>
							</li>
							<li>
								<a
									[routerLink]="['/contact']"
									class="footer-link"
								>
									Contact Us
								</a>
							</li>
						</ul>
					</div>
					<div class="col-md-3">
						<h5>Website</h5>
						<ul class="links-vertical">
							<li>
								<a
									[routerLink]="['/features']"
									class="footer-link"
								>
									Features
								</a>
							</li>
							<li>
								<a [routerLink]="['/pricing']"> Pricing </a>
							</li>
							<li>
								<a
								href="https://regscale.readme.io/" target="_blank"
									class="footer-link"
								>
									Documentation
								</a>
							</li>
							<li>
								<a
									href="https://support.regscale.com/tickets-view?offset=0"
									target="_blank"
									class="footer-link"
								>
									Support Tickets
								</a>
							</li>
							<li>
								<a
									[routerLink]="['/partnership']"
									class="footer-link"
								>
									Partners/Resellers
								</a>
							</li>
						</ul>
					</div>
					<div class="col-md-3">
						<h5>RegScale</h5>
						<ul class="links-vertical">
							<li>
								<a
									href="https://sandbox.regscale.com"
									target="_blank"
								>
									Cloud Sandbox (Customer Preview)
								</a>
							</li>
							<li>
								<a
								[routerLink]="['/training']"
								class="footer-link"
								>
									RegScale University
								</a>
							</li>
						</ul>
					</div>
					<div class="col-md-3">
						<h5 style="margin: 0.5rem">Follow Us</h5>
						<ul class="social-buttons">
							<li>
								<a
									href="https://twitter.com/RegScale"
									class="btn btn-just-icon btn-link btn-twitter"
									target="_blank"
								>
									<img
										src="../assets/img/twitter.svg"
										width="24px"
										alt=""
									/>
								</a>
							</li>
							<li>
								<a
									href="https://www.facebook.com/RegScale"
									class="btn btn-just-icon btn-link btn-facebook"
									target="_blank"
								>
									<img
										src="../assets/img/facebook.svg"
										width="14px"
										alt=""
									/>
								</a>
							</li>
							<li>
								<a
									href="https://www.linkedin.com/company/regscale"
									class="btn btn-just-icon btn-link btn-linkedin"
									target="_blank"
								>
									<img
										src="../assets/img/linkedin.svg"
										width="24px"
										alt=""
									/>
								</a>
							</li>
						</ul>
						<a href="https://www.security-innovation.org/sinet16-award/" target="_blank"><img class="mt-1" style="max-width: 150px;" src="assets/img/sinet.jpg" alt="SINET Award Badge" /></a>
					</div>
				</div>
			</div>
			<hr />
		<div class="copyright pull-center">
			Copyright &#xA9; 2022 - 
			RegScale All Rights Reserved.
		</div>
		<hr />
		<div class="pull-center">
			<a [routerLink]="['/privacy']" class="mr-4">Privacy Policy</a
			><a [routerLink]="['/termsofservice']">Terms of Service</a>
		</div> 
		</div>
	</footer>
</div>
</ng-container>
